import React, { useEffect } from "react";
import "./ghlFormModal.css";

const GHLFormModal = ({ isOpen, onClose, refCodes }) => {

  useEffect(() => {
    const handleMessage = (event) => {

      // OPTIONAL: security check
      if (!event.origin.includes("salesfish.net")) return;

      const data = event.data;

      // Salesfish / GHL submit event
      if (data?.type === "formSubmitted") {
        const formData = data.formData || {};

        const email = formData.email;
        const allFields = formData;

        console.log("Email:", email);
        console.log("All Fields:", allFields);

      
        onClose();
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onClose]);

  if (!isOpen) return null;

  return (
    <div className="ghl-modal-overlay" onClick={onClose}>
      <div className="ghl-modal" onClick={(e) => e.stopPropagation()}>
        <button className="ghl-close" onClick={onClose}>×</button>

        <iframe
          src={`https://link.salesfish.net/widget/form/8HXCKVBLZ3fgCW98QaBa?saved_ref_numbers=${refCodes}`}
          title="Buyer Registration Form"
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
          }}
        />
      </div>
    </div>
  );
};

export default GHLFormModal;
